<!-- 服务切换 -->
<template>
  <div class="address-select">
    <vanPopup
      v-model="showPopup"
      position="bottom"
      :round="true"
      :lock-scroll="false"
      @click-overlay="closePopup"
      v-backFn="{ show: showPopup, closeFn: 'closePopup' }"
    >
      <div class="popup-wrap">
        <div class="popup-head">
          <div class="popup-title os-font-16-500">选择服务方式</div>
          <div class="popup-close" @click="closePopup"></div>
        </div>
        <div class="popup-content">
          <div class="service-list">
            <template v-if="serviceChangeList && serviceChangeList.length">
              <div
                class="service-item"
                :class="{ 'service-item-first': index === 0 }"
                @click="selectConfirm(index)"
                v-for="(item, index) in serviceList"
                :key="index"
              >
                <div class="left-item">
                  <div class="left-item-name os-font-14-500">
                    {{ item.serviceName }}
                  </div>
                  <div class="left-item-tips os-font-12-400">{{ item.serviceTips }}</div>
                </div>
                <div class="right-item"></div>
              </div>
            </template>
            <template v-else>
              <div class="no-result">
                <div class="no-info-img"></div>
                <div class="no-info os-font-14-500">正在加载</div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </vanPopup>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex'

export default {
  name: 'serviceChange',
  props: {
    serviceChangeList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    ...mapState('repair', ['repairType', 'currentAddress', 'quickRepairSendAddressInfo']),
    serviceList() {
      let data = []
      if (this.serviceChangeList && this.serviceChangeList.length > 0) {
        this.serviceChangeList.forEach(item => {
          // 满足条件的才展示 - 寄修始终展示
          const isOK = !this.getServiceChangeRes(item)
          switch (String(item.type)) {
            case '1':
              if (this.repairType == item.type || isOK) {
                break
              }
              data.push(
                Object.assign(item, {
                  serviceName: '预约维修',
                  serviceTips: '预约附近的服务门店到店维修，享优先排队特权'
                })
              )
              break
            case '2':
              if (this.repairType == item.type) {
                break
              }
              data.push(
                Object.assign(item, {
                  serviceName: '寄修服务',
                  serviceTips: '顺丰上门取件，邮寄至较近的服务网点进行维修'
                })
              )
              break
            case '3':
              if (this.repairType == item.type || isOK) {
                break
              }
              data.push(
                Object.assign(item, {
                  serviceName: '上门维修',
                  serviceTips: '工程师上门维修'
                })
              )
              break
            case '6':
              if (this.repairType == item.type || isOK) {
                break
              }
              data.push(
                Object.assign(item, {
                  serviceName: '同城快修',
                  serviceTips: '跑腿小哥同城取送，最快 4 小时完成服务'
                })
              )
              break
          }
        })
      }
      return data
    }
  },
  data() {
    return {
      showPopup: false,
      selectedIndex: -1
    }
  },
  methods: {
    ...mapMutations('repair', [
      'SET_REPAIR_TYPE',
      'SET_SELECTED_PROBLEM_LIST',
      'RESET_STATE',
      'setShowPhoneVerification'
    ]),
    ...mapActions('repair', ['getOldOrder']),
    // 阻止页面滑动
    preventPageScroll() {
      if (this.isPrevent || document.body.classList.contains('isPrevent')) {
        return
      }

      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      this.marginTop = document.body.style.marginTop
      this.height = document.body.style.height
      this.overflow = document.body.style.overflow
      Object.assign(document.body.style, {
        marginTop: -this.scrollTop + 'px',
        height: window.innerHeight + this.scrollTop + 'px',
        overflow: 'hidden'
      })
      document.body.classList.add('isPrevent')
      this.isPrevent = true
    },
    // 恢复页面滑动
    restorePageScroll() {
      if (!this.isPrevent) {
        return
      }

      Object.assign(document.body.style, {
        marginTop: this.marginTop,
        height: this.height,
        overflow: this.overflow
      })
      document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop
      document.body.classList.remove('isPrevent')
      this.isPrevent = false
    },
    getServiceChangeRes(data) {
      if (!data) {
        return false
      }

      // 目标是预约
      if (data.type == 1) {
        // 当前是同城，直接判断经纬度是否支持
        if (this.repairType == 6) {
          this.isQuickRepair = true
          return data.latLongSupport && data.productSupport
        }
      } else {
        return data.addressSupport && data.productSupport
      }
    },
    async serviceCheck(data) {
      let backBasePage = 0

      if (this.repairType === Number(data.type)) {
        // 类型没变，不做处理
        return { backBasePage, type: data.type }
      }

      // 判断机型是否支持
      if (!data.productSupport) {
        backBasePage = 1
      } else if (data.faultTypeIdNotSupport && data.faultTypeIdNotSupport.length > 0) {
        backBasePage = 2
      }

      // 寄修服务请求接口是否存在寄修订单
      if (data.type == 2) {
        await this.getOldOrder()
      }

      return { backBasePage, type: data.type }
    },
    async selectConfirm(index) {
      this.selectService(index)

      const initTips = `已切换至${this.serviceList[this.selectedIndex].serviceName}`
      let resetPosition = false
      if (this.selectedIndex === -1) {
        return
      }
      // 关闭弹窗
      this.closePopup()
      const { backBasePage, type } = await this.serviceCheck(this.serviceList[this.selectedIndex])
      // 重新设置维修类型
      this.repairType != type && this.SET_REPAIR_TYPE(type)
      // 重置手机验证码展示模块
      this.RESET_STATE('showPhoneVerification')

      if (backBasePage) {
        if (backBasePage === 1) {
          // 机型不支持，清空已选择的机型
          this.RESET_STATE('selectedModel')
        }

        // 清除机型列表和故障类型列表
        this.RESET_STATE('modelList')
        this.RESET_STATE('problemList')
        this.RESET_STATE('activeProblems')
        this.RESET_STATE('selectedProblemList')

        this.$router.back()
      } else {
        this.$emit('changeTitle')
        // 同城切预约，使用同城的第一个地址
        if (
          this.repairType == 1 &&
          this.isQuickRepair &&
          this.quickRepairSendAddressInfo.mapLocationPickupAddress.lng
        ) {
          resetPosition = true
        }
        // 切换服务后重置机型列表
        this.RESET_STATE('modelList')
        // 切换到上门需要重置上门时间
        if (this.repairType == 3) {
          this.RESET_STATE('selectedTime')
        }
        this.$emit('changeInit', initTips, resetPosition)
      }
    },
    selectService(index) {
      this.selectedIndex = index
    },
    openPopup() {
      this.preventPageScroll()
      this.showPopup = true
    },
    closePopup() {
      this.restorePageScroll()
      this.showPopup = false
    }
  }
}
</script>

<style lang="scss" scoped>
.popup-wrap {
  max-height: 75vh;
}

.service-list {
  // height: 366px;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 0 16px 16px;

  .service-item {
    padding: 14px 0 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &.service-item-first {
      padding: 12px 0 14px;
    }

    &:not(:last-child) {
      border-bottom: 1px solid #f5f5f5;
    }

    .left-item-name {
      color: #333;
      display: flex;
      align-items: center;
      line-height: 20px;

      .left-item-unSupport {
        margin-left: 5px;
        color: #f10313;
        line-height: 15px;
        display: flex;
        align-items: center;
        height: 16px;
        box-sizing: border-box;
        border: 1px solid #f10313;
        border-radius: 3px;
        padding: 0 3px;
      }
    }

    .left-item-tips {
      line-height: 18px;
      margin-top: 2px;
      color: #999;
    }
  }

  .right-item {
    display: flex;
    align-items: center;

    &::before {
      content: '';
      background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzIyNV82MTQ1IiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiPgo8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiNEOUQ5RDkiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swXzIyNV82MTQ1KSI+CjxtYXNrIGlkPSJtYXNrMV8yMjVfNjE0NSIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iNCIgeT0iMCIgd2lkdGg9IjgiIGhlaWdodD0iMTYiPgo8cmVjdCB4PSI0IiB3aWR0aD0iOCIgaGVpZ2h0PSIxNiIgZmlsbD0iI0Q5RDlEOSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazFfMjI1XzYxNDUpIj4KPHBhdGggZD0iTTUuNDA5NzMgMy4xOTY3MUwxMC4yMTMgOEw1LjQwOTczIDEyLjgwMzMiIHN0cm9rZT0iIzk5OTk5OSIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPC9nPgo8L2c+Cjwvc3ZnPgo=');
      background-size: 100% 100%;
      width: 16px;
      height: 16px;
    }
  }

  .no-result {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .no-info-img {
      width: 30px;
      height: 30px;
      background: url('~@/assets/img/repair/confirm/wap/loading-white.gif') center no-repeat;
      background-size: contain;
    }

    .no-info {
      margin-top: 3px;
      color: #b2b2b2;
    }
  }
}
</style>
